import { colors } from '@constants/colors';
import { IEvent } from '@interfaces/event';
import { IRoom } from '@interfaces/rooms';
import { IUser } from '@interfaces/user';
import type { SxProps } from '@mui/material';

import ParticipantScopes from '@constants/scopes';

import ROUTES from '@constants/routes';
import { IEventParticipant } from '@interfaces/eventParticipant';
import { UserRoles } from '@interfaces/participants';

export const getClientSpecificDashboardTopBarRight = (
  _renderCb: (customSx?: SxProps) => JSX.Element,
) => {
  return null;
};

export const getClientSpecificLastLoadingStepIcon = () => {
  return undefined;
};

export const getClientSpecificNotificationTheme = () => {
  return {
    background: '#03030399',
    color: colors.white,
  };
};

export const getClientSpecificFullScreenHelperVisible = () => {
  return true;
};

export const getClientSpecificLoadingExperienceSpeed = () => {
  return 1;
};

export const getClientSpecificSortedCarouselEvents = (events: IEvent[]) => {
  return events;
};

export const getClientSpecificFeedbackModal = () => {
  return null;
};

export const getClientSpecificTooltipGuide = () => {
  return null;
};

export const getClientSpecificMultiRoleModal = () => {
  return null;
};

export const getClientSpecificDashboardExtension = () => {
  return null;
};

export const getClientSpecificCanShareWebCameraOnScreen = (
  currentRoom: IRoom | null,
  currentEvent: IEvent | undefined,
  permissions?: ParticipantScopes[],
) => {
  const isShareCameraEnable = permissions?.includes(
    ParticipantScopes.HubEventShareCamera,
  );

  return !!currentRoom?.isMultiPlayer && isShareCameraEnable;
};

export const getClientSpecificCanShareScreenOnScreen = (
  currentRoom: IRoom | null,
  currentEvent: IEvent | undefined,
  permissions?: ParticipantScopes[],
) => {
  const isShareScreenEnable = permissions?.includes(
    ParticipantScopes.HubEventShareScreen,
  );

  return !!currentRoom?.isMultiPlayer && isShareScreenEnable;
};

export const getClientSpecificCanShowWebCameraOnAvatar = (
  currentRoom: IRoom | null,
) => {
  return !!currentRoom?.isMultiPlayer;
};

export const getClientSpecificCanSpeak = (currentRoom: IRoom | null) => {
  return !!currentRoom?.isMultiPlayer;
};

export const getClientSpecificAvaturnCarousel = (): string[] => {
  return [];
};

export const getClientSpecificShowNotificationSuccessfulQrCodeScanning =
  (): boolean => {
    return true;
  };

export const getClientSpecificIsLogoClickable = (): boolean => {
  return true;
};

export const getClientSpecificCanTeleport = (
  _currentEvent: IEvent | undefined,
): { canTeleport: boolean; notificationMessage?: string } => {
  return { canTeleport: true };
};

export const getClientSpecificUserEventPermissions = (props: {
  role?: string;
  roleScopes?: { roleName: string; permissions: ParticipantScopes[] }[];
}) => {
  const permissionsRole = props.role ?? UserRoles.EXPERIENCE_MEMBER;

  const permissions = props.roleScopes?.find(
    ({ roleName }) => roleName === permissionsRole,
  )?.permissions;

  return permissions || [];
};

export const getClientSpecificUserEventRole = () => {
  return null;
};

export const getClientSpecificAppLoader = () => {
  return null;
};

export const getClientSpecificEventFullLoadingPage = () => {
  return null;
};

export const getClientSpecificMandatoryLogoutModal = (_events: IEvent[]) => {
  return {
    onCancel: () => {
      window.location.assign(ROUTES.SELECT_EVENT);
    },
  };
};

export const getClientSpecificIsGameCastActionSend = (_props: {
  user: IUser;
  currentEventParticipant: IEventParticipant | null;
}) => {
  return false;
};

export const getClientSpecificInitMessageData = (_props: { user: IUser }) => {
  return {};
};

export const getClientSpecificPageBackgrounds = () => {
  const DefaultBackground = require('@public/images/ScrPlay_BG.png');
  return [DefaultBackground];
};
